/**
 * Warnings, as the remodelled landing page (landing.V2) has it: a
 * thermometer-and-snowflake icon, "Never lose a plant to a surprise frost.",
 * and the two ways it arrives. The evidence is a phone: its status bar, a Grow
 * notification banner ("Grow · now / Cover the eggplants and the lettuce
 * tonight: frost is coming.") and, under it, the real warning email Grow
 * sends (public/landing/warning-email.jpg).
 *
 * The banner is drawn in HTML (a real notification screenshot would be
 * better); the email is the real one. The chores sentence still shows only on
 * a wide screen, where it fits.
 *
 * Words (en/es): landing.v2.warnings.*, and landing.warnings.pain, .bodyMore,
 * .emailAlt.
 *
 * @module WarningsV2
 */

import React from 'react';
import { Sprout, ThermometerSnowflake } from 'lucide-react';
import { useTranslation } from '@/shared/hooks/useTranslation';
import { FeatureBlock } from '../components/FeatureBlock';
import { PhoneFrame } from '../components/PhoneFrame';

/** The warnings section. */
export const WarningsV2: React.FC = () => {
  const { reactTranslate: t } = useTranslation();
  return (
    <FeatureBlock
      icon={<ThermometerSnowflake className="h-8 w-8" strokeWidth={1.75} />}
      quote
      pain={t('landing.warnings.pain')}
      title={t('landing.v2.warnings.title')}
      line={t('landing.v2.warnings.body')}
      more={t('landing.warnings.bodyMore')}
      evidence={(
        <PhoneFrame>
          {/* A phone's notification banner: Grow's icon, the app and "now", then the warning. */}
          <div className="mx-2.5 mb-1 mt-2 flex gap-2.5 rounded-[18px] bg-[rgb(240_242_245/0.95)] px-3 py-2.5 text-left shadow-[0_4px_14px_rgb(0_0_0/0.12)] [font-family:system-ui,-apple-system,'Segoe_UI',sans-serif]">
            <span className="grid h-[30px] w-[30px] shrink-0 place-items-center rounded-lg bg-grow-forest text-grow-cream" aria-hidden="true">
              <Sprout className="h-4 w-4" />
            </span>
            <div className="min-w-0">
              <div className="flex justify-between text-xs text-[#65676B]">
                <b className="font-semibold text-[#1c1a17]">{t('landing.v2.warnings.notification.app')}</b>
                <span>{t('landing.v2.warnings.notification.now')}</span>
              </div>
              <div className="text-[13px] leading-[1.3] text-[#1c1a17]">{t('landing.v2.warnings.notification.text')}</div>
            </div>
          </div>
          <img src="/landing/warning-email.jpg" alt={t('landing.warnings.emailAlt')} loading="lazy" className="block w-full" />
        </PhoneFrame>
      )}
    />
  );
};
